(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navbar"]) return;
  try {
    
document.addEventListener('click', function(event) {
    if (event.target.matches('[data-action="language-switch"]') || event.target.closest('[data-action="language-switch"]')) {
        event.preventDefault();
        const element = event.target.matches('[data-action="language-switch"]') ? 
                       event.target : 
                       event.target.closest('[data-action="language-switch"]');
        
        const languageCode = element.getAttribute('data-language-code');
        const shopifyLocaleUrl = '/localization';
        
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = shopifyLocaleUrl;
        
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = '_method';
        input.value = 'put';
        form.appendChild(input);
        
        const localeInput = document.createElement('input');
        localeInput.type = 'hidden';
        localeInput.name = 'locale_code';
        localeInput.value = languageCode;
        form.appendChild(localeInput);
        
        const returnToInput = document.createElement('input');
        returnToInput.type = 'hidden';
        returnToInput.name = 'return_to';
        returnToInput.value = window.location.pathname;
        form.appendChild(returnToInput);
        
        document.body.appendChild(form);
        form.submit();
    }

    if (event.target.matches('[data-action="currency-switch"]') || event.target.closest('[data-action="currency-switch"]')) {
        event.preventDefault();
        const element = event.target.matches('[data-action="currency-switch"]') ? 
                       event.target : 
                       event.target.closest('[data-action="currency-switch"]');
        
        const currencyCode = element.getAttribute('data-currency-code');
        const shopifyLocaleUrl = '/localization';
        
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = shopifyLocaleUrl;
        
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = '_method';
        input.value = 'put';
        form.appendChild(input);
        
        const currencyInput = document.createElement('input');
        currencyInput.type = 'hidden';
        currencyInput.name = 'currency_code';
        currencyInput.value = currencyCode;
        form.appendChild(currencyInput);
        
        const returnToInput = document.createElement('input');
        returnToInput.type = 'hidden';
        returnToInput.name = 'return_to';
        returnToInput.value = window.location.pathname;
        form.appendChild(returnToInput);
        
        document.body.appendChild(form);
        form.submit();
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  // 这个文件底部已有一个更好的JavaScript实现，所以这里不需要重复代码

  } catch(e) { console.error(e); }
})();
})();
